module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"staff_picks":"Staff Picks"},"ja":{"staff_picks":"サイトスタッフ一押し"}}')
  delete Component.options._Ctor
}
